module.exports = __webpack_public_path__ + "static/img/icon3.e6f6e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon3.png
// module id = akCb
// module chunks = 0